module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/footers/footers.component.scss
// module id = ./src/app/footers/footers.component.scss
// module chunks = main